module.exports = __webpack_public_path__ + "img/picture_kydeb.905c06a3.png";